import { ContentRoute } from '../../models/Route';
import WebhookMattermostList from './WebhookMattermostList';
import WebhookMattermostForm from './WebhookMattermostForm';

const mattermost_content_routes: Array<ContentRoute> = [
    {
        path: '/mattermost',
        description: 'Webhooks Mattermost',
        exact: true,
        component: WebhookMattermostList,
        menu: true,
    },
    {
        path: '/mattermost/webhook/incluir',
        description: 'Incluir',
        exact: true,
        component: WebhookMattermostForm,
        menu: false,
    },
    {
        path: '/mattermost/webhook/visualizar/:id',
        description: 'Visualizar',
        exact: true,
        component: WebhookMattermostForm,
        menu: false,
    },
    {
        path: '/mattermost/webhook/alterar/:id',
        description: 'Alterar',
        exact: true,
        component: WebhookMattermostForm,
        menu: false,
    },
];

export default mattermost_content_routes;
